import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import IndexPage from 'flarum/forum/components/IndexPage';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import LogInModal from 'flarum/forum/components/LogInModal';
import Stream from 'flarum/common/utils/Stream';

const MOODLE_URL = 'https://preparaoposiciones.com';

const categories = [
  { name: 'Justicia', url: MOODLE_URL + '/course/index.php?categoryid=2' },
  { name: 'Administracion General', url: MOODLE_URL + '/course/index.php?categoryid=3' },
  { name: 'Fuerzas de Seguridad', url: MOODLE_URL + '/course/index.php?categoryid=4' },
  { name: 'Hacienda', url: MOODLE_URL + '/course/index.php?categoryid=5' },
  { name: 'Educacion', url: MOODLE_URL + '/course/index.php?categoryid=6' },
  { name: 'Sanidad', url: MOODLE_URL + '/course/index.php?categoryid=7' },
  { name: 'Correos', url: MOODLE_URL + '/course/index.php?categoryid=8' },
  { name: 'Ver todas', url: MOODLE_URL + '/course/' },
];

const resources = [
  { name: 'Test Gratis', icon: '✍️', url: '/blog/test-gratis/' },
  { name: 'Simulacros de Examen', icon: '🎯', url: '/blog/simulacros-examen-oposiciones/' },
  { name: 'Esquemas de Leyes', icon: '📋', url: '/blog/esquemas/' },
  { name: 'Exámenes Oficiales', icon: '📄', url: '/blog/examenes-oficiales/' },
  { name: 'Casos Prácticos', icon: '📝', url: '/blog/casos-practicos/' },
  { name: 'Flashcards', icon: '🗂️', url: '/blog/flashcards-oposiciones/' },
  { name: 'Blog', icon: '📰', url: '/blog/' },
];

const tools = [
  { name: 'Mi progreso', icon: '📊', url: MOODLE_URL + '/my/' },
  { name: 'Planificador', icon: '🗓️', url: '/blog/planificador-oposiciones/' },
  { name: 'Ranking', icon: '🏆', url: MOODLE_URL + '/my/' },
  { name: 'Logros', icon: '🎖️', url: MOODLE_URL + '/my/' },
];

// SVG icons as functions
function chevronSvg() {
  return m('svg.chevron', { width: 12, height: 12, fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor' },
    m('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M19 9l-7 7-7-7' })
  );
}

function userSvg() {
  return m('svg', { width: 16, height: 16, fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor' },
    m('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' })
  );
}

function hamburgerSvg() {
  return m('svg', { width: 24, height: 24, fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor' },
    m('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M4 6h16M4 12h16M4 18h16' })
  );
}

function closeSvg() {
  return m('svg', { width: 24, height: 24, fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor' },
    m('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M6 18L18 6M6 6l12 12' })
  );
}

function moonSvg() {
  return m('svg', { width: 16, height: 16, fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor', 'stroke-width': '1.8', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }, [
    m('path', { d: 'M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z' }),
    m('path', { d: 'M17 4l.5 1 1 .5-1 .5-.5 1-.5-1-1-.5 1-.5z', fill: 'currentColor', stroke: 'none' }),
    m('path', { d: 'M20 9l.4.8.8.4-.8.4-.4.8-.4-.8-.8-.4.8-.4z', fill: 'currentColor', stroke: 'none' }),
  ]);
}

function sunSvg() {
  return m('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }, [
    m('circle', { cx: 12, cy: 12, r: 4 }),
    m('path', { d: 'M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41' }),
  ]);
}

// Social icons for footer
function instagramSvg() {
  return m('svg', { width: 20, height: 20, fill: 'currentColor', viewBox: '0 0 24 24' },
    m('path', { d: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z' })
  );
}

function twitterSvg() {
  return m('svg', { width: 20, height: 20, fill: 'currentColor', viewBox: '0 0 24 24' },
    m('path', { d: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' })
  );
}

function youtubeSvg() {
  return m('svg', { width: 20, height: 20, fill: 'currentColor', viewBox: '0 0 24 24' },
    m('path', { d: 'M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' })
  );
}

function telegramSvg() {
  return m('svg', { width: 20, height: 20, fill: 'currentColor', viewBox: '0 0 24 24' },
    m('path', { d: 'M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z' })
  );
}

app.initializers.add('preparaoposiciones-theme', () => {
  let scrolled = false;
  let mobileMenuOpen = false;

  // Scroll listener
  window.addEventListener('scroll', () => {
    const wasScrolled = scrolled;
    scrolled = window.scrollY > 20;
    if (wasScrolled !== scrolled) m.redraw();
  }, { passive: true });

  // Dark mode: sync with blog's localStorage.theme
  function isDark() {
    return localStorage.getItem('theme') === 'dark' ||
      (!localStorage.getItem('theme') && window.matchMedia('(prefers-color-scheme: dark)').matches);
  }

  function toggleDarkMode() {
    const next = !isDark();
    localStorage.setItem('theme', next ? 'dark' : 'light');
    document.documentElement.classList.toggle('dark', next);
    document.body.classList.toggle('nightmode', next);
    m.redraw();
  }

  // Apply dark mode on load
  if (isDark()) {
    document.documentElement.classList.add('dark');
    document.body.classList.add('nightmode');
  }

  // Listen for storage changes (cross-tab sync with blog)
  window.addEventListener('storage', (e) => {
    if (e.key === 'theme') {
      const dark = e.newValue === 'dark';
      document.documentElement.classList.toggle('dark', dark);
      document.body.classList.toggle('nightmode', dark);
      m.redraw();
    }
  });

  // Build header component
  function renderHeader() {
    return m('nav.po-header' + (scrolled ? '.scrolled' : ''), [
      m('.po-header-inner', [
        // Logo
        m('a.po-logo', { href: MOODLE_URL, title: 'PreparaOposiciones' }, [
          'Prepara', m('span', 'Oposiciones')
        ]),

        // Mobile hamburger
        m('button.po-mobile-toggle', {
          onclick: (e) => { e.preventDefault(); mobileMenuOpen = !mobileMenuOpen; },
          'aria-label': 'Menu'
        }, mobileMenuOpen ? closeSvg() : hamburgerSvg()),

        // Desktop nav
        m('.po-nav', [
          m('a.po-nav-link', { href: MOODLE_URL }, 'Inicio'),
          m('a.po-nav-link', { href: MOODLE_URL + '/course/' }, 'Cursos'),

          // Explorar megamenu
          m('.po-dropdown', [
            m('a.po-dropdown-trigger', { href: MOODLE_URL + '/course/' }, [
              m('span', 'Explorar'), chevronSvg()
            ]),
            m('.po-dropdown-menu.po-megamenu', [
              m('.po-mega-grid', [
                // Categories column
                m('div', [
                  m('p.po-mega-heading', 'Categorias'),
                  m('ul.po-mega-list', categories.map(cat =>
                    m('li', m('a', { href: cat.url }, cat.name))
                  ))
                ]),
                // Resources column
                m('div', [
                  m('p.po-mega-heading', 'Recursos'),
                  m('ul.po-mega-list', resources.map(res =>
                    m('li', m('a', { href: res.url }, [m('span', res.icon), ' ', res.name]))
                  ))
                ]),
                // Tools column
                m('div', [
                  m('p.po-mega-heading', 'Herramientas'),
                  m('ul.po-mega-list', tools.map(tool =>
                    m('li', m('a', { href: tool.url }, [m('span', tool.icon), ' ', tool.name]))
                  ))
                ]),
                // CTA column
                m('div', [
                  m('.po-mega-cta', [
                    m('.cta-title', 'Empieza gratis'),
                    m('p.cta-text', 'Accede a tests gratuitos y descubre tu nivel'),
                    m('a.cta-btn', { href: MOODLE_URL + '/login/signup.php' }, 'Registrarse')
                  ])
                ])
              ])
            ])
          ]),

          m('a.po-nav-link', { href: '/blog/' }, 'Blog'),

          // Herramientas dropdown
          m('.po-dropdown', [
            m('a.po-dropdown-trigger', { href: '/blog/herramientas/' }, [
              m('span', 'Herramientas'), chevronSvg()
            ]),
            m('.po-dropdown-menu', [
              m('a.po-dropdown-item', { href: '/blog/herramientas/calendario/' }, [
                m('span.item-icon', '📅'),
                m('.item-info', [
                  m('.item-title', 'Calendario Convocatorias'),
                  m('.item-desc', 'Fechas y plazos actualizados')
                ])
              ]),
              m('a.po-dropdown-item', { href: '/blog/herramientas/calculadora-sueldo/' }, [
                m('span.item-icon', '💰'),
                m('.item-info', [
                  m('.item-title', 'Calculadora de Sueldo'),
                  m('.item-desc', 'Sueldo por grupo y trienios')
                ])
              ]),
              m('a.po-dropdown-item', { href: '/blog/herramientas/calculadora-nota-test/' }, [
                m('span.item-icon', '📊'),
                m('.item-info', [
                  m('.item-title', 'Calculadora de Nota'),
                  m('.item-desc', 'Nota con penalización oficial')
                ])
              ]),
              m('a.po-dropdown-item', { href: '/blog/herramientas/calculadora-coste-opositar/' }, [
                m('span.item-icon', '🧮'),
                m('.item-info', [
                  m('.item-title', 'Coste de Opositar'),
                  m('.item-desc', 'Academia, temario, tasas y ROI')
                ])
              ]),
              m('a.po-dropdown-item', { href: '/blog/herramientas/notas-de-corte/' }, [
                m('span.item-icon', '📈'),
                m('.item-info', [
                  m('.item-title', 'Notas de Corte'),
                  m('.item-desc', 'Histórico y predicción 2026')
                ])
              ]),
              m('a.po-dropdown-item', { href: '/blog/simulacros-examen-oposiciones/' }, [
                m('span.item-icon', '🎯'),
                m('.item-info', [
                  m('.item-title', 'Simulacros de Examen'),
                  m('.item-desc', 'Practica como en el examen real')
                ])
              ]),
              m('a.po-dropdown-item', { href: '/blog/herramientas/test-vocacional/' }, [
                m('span.item-icon', '🧭'),
                m('.item-info', [
                  m('.item-title', 'Test Vocacional'),
                  m('.item-desc', 'Descubre tu oposición ideal')
                ])
              ])
            ])
          ]),

          m('a.po-nav-link.active', { href: '/foro/' }, 'Foro'),
        ]),

        // Right side
        m('.po-header-right', [
          m('button.po-btn-login', { onclick: () => app.modal.show(LogInModal) }, [userSvg(), ' Acceder']),
          m('button.po-btn-register', { onclick: () => app.modal.show(SignUpModal) }, 'Registrarse'),
          m('button.po-dark-toggle', {
            onclick: toggleDarkMode,
            'aria-label': isDark() ? 'Activar modo claro' : 'Activar modo oscuro',
            title: isDark() ? 'Modo claro' : 'Modo oscuro'
          }, isDark() ? sunSvg() : moonSvg()),
        ]),
      ]),

      // Mobile menu
      m('.po-mobile-menu' + (mobileMenuOpen ? '.open' : ''), [
        m('.po-mobile-backdrop', { onclick: () => { mobileMenuOpen = false; } }),
        m('.po-mobile-panel', { onclick: (e) => e.stopPropagation() }, [
          m('a.po-mobile-link', { href: MOODLE_URL }, 'Inicio'),
          m('a.po-mobile-link', { href: MOODLE_URL + '/course/' }, 'Cursos'),

          m('.po-mobile-section', [
            m('span.po-mobile-section-title', 'Explorar'),
            categories.map(cat =>
              m('a.po-mobile-link', { href: cat.url }, cat.name)
            )
          ]),

          m('.po-mobile-section', [
            m('a.po-mobile-link', { href: '/blog/', style: { fontWeight: 500 } }, 'Blog'),
          ]),

          m('.po-mobile-section', [
            m('span.po-mobile-section-title', 'Herramientas'),
            m('a.po-mobile-link', { href: '/blog/herramientas/calendario/' }, '📅 Calendario Convocatorias'),
            m('a.po-mobile-link', { href: '/blog/herramientas/calculadora-sueldo/' }, '💰 Calculadora de Sueldo'),
            m('a.po-mobile-link', { href: '/blog/herramientas/calculadora-nota-test/' }, '📊 Calculadora de Nota'),
            m('a.po-mobile-link', { href: '/blog/herramientas/calculadora-coste-opositar/' }, '🧮 Coste de Opositar'),
            m('a.po-mobile-link', { href: '/blog/herramientas/notas-de-corte/' }, '📈 Notas de Corte'),
            m('a.po-mobile-link', { href: '/blog/herramientas/calculadora-probabilidad/' }, '🎲 Probabilidad de Temas'),
            m('a.po-mobile-link', { href: '/blog/herramientas/test-vocacional/' }, '🧭 Test Vocacional'),
          ]),

          m('.po-mobile-section', [
            m('a.po-mobile-link', { href: '/foro/', style: { fontWeight: 700 } }, 'Foro'),
          ]),

          m('.po-mobile-darkmode', [
            m('span.label', 'Modo oscuro'),
            m('button.po-dark-toggle', {
              onclick: toggleDarkMode,
              'aria-label': isDark() ? 'Activar modo claro' : 'Activar modo oscuro',
            }, isDark() ? sunSvg() : moonSvg()),
          ]),

          m('.po-mobile-section', [
            m('.po-mobile-actions', [
              m('button.login-btn', { onclick: () => { mobileMenuOpen = false; app.modal.show(LogInModal); } }, [userSvg(), ' Acceder']),
              m('button.register-btn', { onclick: () => { mobileMenuOpen = false; app.modal.show(SignUpModal); } }, 'Registrarse'),
            ])
          ]),
        ])
      ])
    ]);
  }

  // Build footer component
  function renderFooter() {
    return m('.po-footer', [
      m('.po-footer-inner', [
        m('.po-footer-grid', [
          // Column 1: Sobre nosotros
          m('div', [
            m('p.po-footer-heading', 'Sobre nosotros'),
            m('ul.po-footer-list', [
              m('li', m('a', { href: '/blog/sobre-nosotros/' }, 'Quiénes somos')),
              m('li', m('a', { href: '/blog/metodologia/' }, 'Metodología editorial')),
              m('li', m('a', { href: MOODLE_URL + '/legal/como-funciona' }, 'Cómo funciona')),
              m('li', m('a', { href: MOODLE_URL + '/legal/contacto' }, 'Contacto')),
              m('li', m('a', { href: MOODLE_URL + '/legal/faq' }, 'Preguntas frecuentes')),
              m('li', m('a', { href: MOODLE_URL + '/legal/terminos' }, 'Aviso legal')),
              m('li', m('a', { href: MOODLE_URL + '/legal/privacidad' }, 'Política de privacidad')),
            ])
          ]),

          // Column 2: Oposiciones
          m('div', [
            m('p.po-footer-heading', 'Oposiciones'),
            m('ul.po-footer-list', [
              m('li', m('a', { href: '/blog/cursos/auxilio-judicial/' }, 'Justicia')),
              m('li', m('a', { href: '/blog/cursos/auxiliar-administrativo-estado/' }, 'Administración General')),
              m('li', m('a', { href: '/blog/cursos/policia-nacional/' }, 'Fuerzas de Seguridad')),
              m('li', m('a', { href: '/blog/cursos/correos/' }, 'Correos')),
              m('li', m('a', { href: '/blog/cursos/' }, 'Todos los cursos')),
            ])
          ]),

          // Column 3: Recursos
          m('div', [
            m('p.po-footer-heading', 'Recursos'),
            m('ul.po-footer-list', [
              m('li', m('a', { href: '/blog/' }, 'Blog')),
              m('li', m('a', { href: '/blog/convocatorias/' }, 'Convocatorias')),
              m('li', m('a', { href: '/blog/guias/' }, 'Guías de estudio')),
              m('li', m('a', { href: '/blog/noticias/' }, 'Noticias')),
              m('li', m('a', { href: '/blog/simulacros-examen-oposiciones/' }, 'Simulacros de examen')),
              m('li', m('a', { href: '/blog/planificador-oposiciones/' }, 'Planificador')),
              m('li', m('a', { href: '/foro/' }, 'Foro Comunidad')),
              m('li', m('a', { href: '/blog/test-gratis/' }, 'Test gratuitos')),
              m('li', m('a', { href: '/blog/casos-practicos/' }, 'Casos prácticos')),
              m('li', m('a', { href: '/blog/historias-exito/' }, 'Historias de éxito')),
              m('li', m('a', { href: '/blog/observatorio/' }, 'Observatorio 2026')),
            ])
          ]),

          // Column 4: Newsletter + Social
          m('div', [
            m('p.po-footer-heading', 'Newsletter'),
            m('p.po-footer-newsletter-text', 'Recibe convocatorias y noticias de oposiciones en tu email.'),
            m('.po-footer-social', [
              m('a', { href: 'https://www.instagram.com/preparaoposiciones_/', target: '_blank', rel: 'noopener noreferrer', title: 'Instagram' }, instagramSvg()),
              m('a', { href: 'https://twitter.com/preparaopos', target: '_blank', rel: 'noopener noreferrer', title: 'Twitter' }, twitterSvg()),
              m('a', { href: 'https://www.youtube.com/@preparaoposiciones', target: '_blank', rel: 'noopener noreferrer', title: 'YouTube' }, youtubeSvg()),
              m('a', { href: 'https://t.me/preparaoposiciones', target: '_blank', rel: 'noopener noreferrer', title: 'Telegram' }, telegramSvg()),
            ])
          ]),
        ]),

        // Bottom bar
        m('.po-footer-bottom', [
          m('p.po-footer-copyright', '\u00A9 ' + new Date().getFullYear() + ' PreparaOposiciones. Todos los derechos reservados.'),
          m('.po-footer-legal', [
            m('a', { href: MOODLE_URL + '/legal/terminos' }, 'Aviso legal'),
            m('a', { href: MOODLE_URL + '/legal/privacidad' }, 'Privacidad'),
          ])
        ])
      ])
    ]);
  }

  // Inject header and footer into the DOM
  extend(HeaderPrimary.prototype, 'oncreate', function () {
    // Only inject once
    if (document.querySelector('.po-header')) return;

    const headerEl = document.createElement('div');
    headerEl.id = 'po-header-mount';
    document.body.insertBefore(headerEl, document.body.firstChild);
    m.mount(headerEl, { view: renderHeader });
  });

  // Inject footer after #app
  extend(HeaderPrimary.prototype, 'oncreate', function () {
    if (document.querySelector('.po-footer')) return;

    const footerEl = document.createElement('div');
    footerEl.id = 'po-footer-mount';
    const appEl = document.getElementById('app');
    if (appEl && appEl.parentNode) {
      appEl.parentNode.insertBefore(footerEl, appEl.nextSibling);
    } else {
      document.body.appendChild(footerEl);
    }
    m.mount(footerEl, { view: renderFooter });
  });

  // Welcome banner for non-authenticated users
  function renderWelcomeBanner() {
    return m('.po-welcome-banner', [
      m('.po-welcome-inner', [
        m('.po-welcome-content', [
          m('h2.po-welcome-title', 'Bienvenido a la Comunidad de Opositores'),
          m('p.po-welcome-text', 'Comparte experiencias, resuelve dudas y prepara tu oposicion junto a otros companeros.'),
          m('.po-welcome-actions', [
            m('a.po-welcome-btn.primary', {
              href: '#',
              onclick: (e) => {
                e.preventDefault();
                app.modal.show(SignUpModal);
              }
            }, 'Unirme a la comunidad'),
            m('a.po-welcome-btn.secondary', { href: app.forum.attribute('baseUrl') + '/p/normas' }, 'Ver normas'),
          ]),
        ]),
        m('button.po-welcome-close', {
          onclick: () => {
            localStorage.setItem('po-banner-dismissed', '1');
            m.redraw();
          },
          'aria-label': 'Cerrar'
        }, m('svg', { width: 20, height: 20, fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor' },
          m('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M6 18L18 6M6 6l12 12' })
        )),
      ]),
    ]);
  }

  extend(IndexPage.prototype, 'hero', function (vdom) {
    if (app.session.user || localStorage.getItem('po-banner-dismissed')) {
      return;
    }
    return m('div', [vdom, renderWelcomeBanner()]);
  });

  // Breadcrumb on tag pages — inject via view extend since hero() return
  // gets consumed before our extend can wrap it reliably
  extend(IndexPage.prototype, 'oncreate', function () {
    const tag = this.currentTag && this.currentTag();
    if (!tag) return;
    if (document.querySelector('.po-breadcrumb')) return;

    const hero = this.element.querySelector('.Hero');
    if (!hero) return;

    const el = document.createElement('div');
    el.className = 'po-breadcrumb';
    hero.parentNode.insertBefore(el, hero);

    const baseUrl = app.forum.attribute('baseUrl');
    const parent = tag.parent && tag.parent();

    m.mount(el, {
      view: () => m('nav.po-breadcrumb-inner', [
        m('.container', [
          m('a.po-breadcrumb-link', { href: baseUrl, oncreate: (vnode) => { vnode.dom.addEventListener('click', (e) => { e.preventDefault(); m.route.set(baseUrl); }); } }, [
            m('svg', { width: 14, height: 14, fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor', style: { verticalAlign: '-2px', marginRight: '4px' } },
              m('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2', d: 'M15 19l-7-7 7-7' })
            ),
            'Foro'
          ]),
          m('span.po-breadcrumb-sep', '/'),
          parent ? [
            m('a.po-breadcrumb-link', { href: baseUrl + '/t/' + parent.slug() }, parent.name()),
            m('span.po-breadcrumb-sep', '/'),
          ] : null,
          m('span.po-breadcrumb-current', tag.name()),
        ])
      ])
    });
  });

  // Clean up breadcrumb on page change
  extend(IndexPage.prototype, 'onremove', function () {
    const el = document.querySelector('.po-breadcrumb');
    if (el) {
      m.mount(el, null);
      el.remove();
    }
  });

  // === SignUpModal: Add firstname/lastname fields ===

  // Initialize streams for name fields
  extend(SignUpModal.prototype, 'oninit', function () {
    this.firstname = Stream('');
    this.lastname = Stream('');
  });

  // Add firstname and lastname fields to the registration form
  extend(SignUpModal.prototype, 'fields', function (items) {
    items.add('firstname',
      m('.Form-group',
        m('input.FormControl', {
          name: 'firstname',
          type: 'text',
          placeholder: 'Nombre',
          bidi: this.firstname,
          disabled: this.loading,
          required: true,
        })
      ), 35); // priority 35 = above username (30)

    items.add('lastname',
      m('.Form-group',
        m('input.FormControl', {
          name: 'lastname',
          type: 'text',
          placeholder: 'Apellidos',
          bidi: this.lastname,
          disabled: this.loading,
          required: true,
        })
      ), 33); // priority 33 = between firstname (35) and username (30)
  });

  // Include firstname/lastname in submit data
  extend(SignUpModal.prototype, 'submitData', function (data) {
    data.firstname = this.firstname();
    data.lastname = this.lastname();
  });
});
